import React from 'react';
import './RecipeCardSkeleton.css';

const RecipeCardSkeleton = () => (
  <div className="recipe-card skeleton-card" aria-hidden="true">
    <div className="sk sk-header" />
    <div className="sk sk-title" />
    <div className="sk sk-image" />
    <div className="sk sk-actions" />
    <div className="sk sk-comment" />
  </div>
);

export default RecipeCardSkeleton;